import logo from './logo.svg';
import './App.css';
import React from 'react';
import TsstMain from './TsstMain.js';

// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';

import { getQuestionList } from './questionList';

//function App() {
class App extends React.Component {

  questionListItems = getQuestionList().map((questionStr) => 
    <li>{questionStr[0]}</li>
  );

  render() {
    return (
      <div className="App">
        <Container>
          <Row>
            <h1>TSST練習サイト</h1>
            <div>ALCの英語スピーキングテストのTSST（Telephone Standard Speaking Test）の練習用サイトです。テストを受けることになり練習用にと作成しました。</div>
          </Row>
          <Row>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>TSSTとは？</Accordion.Header>
                <Accordion.Body>
                  英語の自動音声電話でスピーキング能力をテストする試験です。<br />
                  電話でいつでもテストができ、自動音声の問題１０問に対して、１問あたり４５秒で英語で自由に話すテストです。
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>サイトの使い方</Accordion.Header>
                <Accordion.Body>
                  開始を押すとランダムに問題を表示して読み上げ、読み上げ後に４５秒のカウントダウンが始まります。<br />
                  ４５行後に「次へ」を押すと次の問題を読み上げます。<br />
                  ※本サイトの音声は現状、日本語のみです。（実際のテストでは日本語と英語を読み上げます）
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Row>
          <Row>
            <TsstMain />
          </Row>
          <Row>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>練習問題リスト</Accordion.Header>
                <Accordion.Body>
                  <ul className="question-list">{this.questionListItems}</ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Row>
        </Container>
      </div>
    );
  }
}

export default App;
